import Vue from 'vue';
import App from './App.vue';
// 引入初始样式
import CustomConfirm from '@/components/CustomConfirm.vue';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/css/global.less";
import "./assets/font/iconfont.css";
import './permission';
import router from './router';
import store from './store';
import "./util/element.js";
import "./util/http.js";

Vue.config.productionTip = false

Vue.prototype.$customConfirm = function (options = {}) {
  const ConfirmClass = Vue.extend(CustomConfirm)
  const instance = new ConfirmClass({
    propsData: options
  })
  instance.$mount()
  document.body.appendChild(instance.$el)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
